import LeaveList from '@/controllers/leave/leave-list.js';

export default {
  extends: LeaveList,
}
